/*
 * StudentConsentItems Messages
 *
 * This contains all the text for the StudentConsentItems component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.containers.ConsentPage.title',
    defaultMessage: 'Consents',
  },
  title: {
    id: 'app.components.StudentsConsents.title',
    defaultMessage: 'Consents for your children',
  },
  noStudents: {
    id: 'app.components.StudentsConsents.noStudents',
    defaultMessage: 'No students found',
  },
  parentsOnly: {
    id: 'app.containers.ParentMeetingsPage.connected',
    defaultMessage: 'This page is for parents only',
  },
});
